import { Input } from "@nextui-org/react";
import React from "react";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
}) => {
  return (
    <Input
      className={className}
      classNames={{
        base: "h-[36px]",
        mainWrapper: "h-[36px]",
        inputWrapper: "h-[36px] bg-[#FAFAFA] border-1 border-[#E4E4E7] rounded-[6px] px-3 py-2 gap-2 hover:bg-[#FAFAFA] group-data-[focus=true]:bg-[#FAFAFA] data-[hover=true]:bg-[#FAFAFA]",
        input: "font-['Inter'] font-normal text-[14px] leading-[20px] text-[#71717A] placeholder:text-[#71717A]",
        innerWrapper: "gap-2",
      }}
      startContent={
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7" cy="7" r="5.5" stroke="#7F7F87" strokeWidth="1"/>
          <line x1="11.0607" y1="11" x2="14" y2="13.9393" stroke="#7F7F87" strokeWidth="1" strokeLinecap="round"/>
        </svg>
      }
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
